import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Header from "./layouts/Header";
import { Grid, TextField, Paper, Typography, MenuItem, InputLabel, FormControl, Select, Autocomplete, Button, Skeleton, Box, Tabs, Tab } from "@mui/material";

import { fetchErrorMessages, selectErrorMessagesByKeyName } from "../reducers/reference_errormessages";
import Footer from "./layouts/Footer";
import { fetchPublicViewInstances, fetchViewInstances, selectViewInstanceById, viewinstanceClear } from "../reducers/reuseable_vi";
import ProfileDemographicsCard from "./partials/profile/ProfileDemographicsCard";
import ProfilePreviousAssessmentCard from "./partials/profile/ProfilePreviousAssessmentCard";
import { globalsettingSetAll, selectGlobalSettingEntities } from "../reducers/reference_settings";
import '../print.css'

//import { getPWRequest } from "../actions/viewinstance";

const Profile = (props) => {
  const navigate = useNavigate()
  const ProfileDemographicsVI = useSelector(state => selectViewInstanceById(state, "ProfileDemographics"))
  const { user: currentUser } = useSelector((state) => state.auth);
  const [value, setValue] = React.useState(0);


  const errormessageStatus = useSelector(state => state.errormessages.status)
  const settingStatus = useSelector(state => state.globalsettings.status)
  const [settingsLoaded, setSettingsLoaded] = React.useState(false);
  const [ProfileDemographicsCalled, setProfileDemographicsCalled] = useState(false)
  const settings = useSelector(state => selectGlobalSettingEntities(state))

  const dispatch = useDispatch()

  useEffect(() => {
    if (ProfileDemographicsVI && ProfileDemographicsVI?.status === 'success' && ProfileDemographicsVI.settings && !settingsLoaded) {
      dispatch(globalsettingSetAll({ Settings: ProfileDemographicsVI.settings }))
    }
  }, [ProfileDemographicsVI, settingsLoaded, settingStatus, dispatch])

  useEffect(() => {
    if (ProfileDemographicsVI?.status === 'success' && !settingsLoaded) {
      setSettingsLoaded(true)
    }

  }, [settingsLoaded, settingStatus, settings, dispatch])

  useEffect(() => {
    if (!ProfileDemographicsVI && ProfileDemographicsVI?.status !== 'failed') {
      dispatch(fetchViewInstances({ VIName: "ProfileDemographics", VIGuid: '5F6382C5-1CEF-461B-9539-7B428E5EA882', authToken: currentUser.AuthToken }))
    }
  }, [])

  useEffect(() => {
    if (errormessageStatus === 'idle') {
      dispatch(fetchErrorMessages({ groupGuid: localStorage.getItem('group'), languageID: -1 }))
    }
  }, [errormessageStatus, dispatch])

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <div>
      <Header type="PRPS" />
      <Paper elevation={16} style={{ marginTop: '150px', padding: '16px' }}>
        <Box width="100%">
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              {/* <Tab label={"My Overview"} /> */}
              {ProfileDemographicsVI?.status === 'success' && settingsLoaded && settingStatus === 'success' ? (

                <Tab label={ProfileDemographicsVI.ProfileVI.MenuProfile.ProfileText.HistoryTabText} />

              )
                : (
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                )
              }
              {ProfileDemographicsVI?.status === 'success' && settingsLoaded && settingStatus === 'success' ? (

                <Tab label={ProfileDemographicsVI.ProfileVI.MenuProfile.ProfileText.InformationTabText} />
              )
                : (
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                )
              }

            </Tabs>
            {/* <Box display={value === 0 ? "block" : "none"}>

            </Box> */}
            <Box display={value === 0 ? "block" : "none"}>
              {ProfileDemographicsVI?.status === 'success' && settingsLoaded && settingStatus === 'success' ? (

                <ProfilePreviousAssessmentCard />
              )
                : (
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                )
              }

            </Box>
            <Box display={value === 1 ? "block" : "none"}>

              {ProfileDemographicsVI?.status === 'success' && settingsLoaded && settingStatus === 'success' ? (

                <ProfileDemographicsCard />
              )
                : (
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                )
              }
            </Box>
          </Box>
        </Box>

      </Paper>


      <Footer />
    </div>
  );


};

export default Profile;